/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    baseUrl = '';
    securityData = null;
    securityWorker;
    abortControllers = new Map();
    customFetch = (...fetchParams) => fetch(...fetchParams);
    baseApiParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    };
    constructor(apiConfig = {}) {
        Object.assign(this, apiConfig);
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join('&');
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join('&');
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }
    contentFormatters = {
        [ContentType.Json]: (input) => input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
        [ContentType.Text]: (input) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
        [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData()),
        [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
    };
    mergeRequestParams(params1, params2) {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    createAbortSignal = (cancelToken) => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }
        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };
    abortRequest = (cancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);
        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };
    request = async ({ body, secure, path, type, query, format, baseUrl, cancelToken, ...params }) => {
        const secureParams = ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;
        return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response.clone();
            r.data = null;
            r.error = null;
            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                    .then((data) => {
                    if (r.ok) {
                        r.data = data;
                    }
                    else {
                        r.error = data;
                    }
                    return r;
                })
                    .catch((e) => {
                    r.error = e;
                    return r;
                });
            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }
            if (!response.ok)
                throw data;
            return data;
        });
    };
}
/**
 * @title Deluge API
 * @version 0.1.0
 */
export class TradeApiClient extends HttpClient {
    health = {
        /**
         * No description
         *
         * @name HealthList
         * @request GET:/health
         */
        healthList: (params = {}) => this.request({
            path: `/health`,
            method: 'GET',
            format: 'json',
            ...params,
        }),
    };
    metrics = {
        /**
         * No description
         *
         * @name MetricsList
         * @request GET:/metrics
         */
        metricsList: (params = {}) => this.request({
            path: `/metrics`,
            method: 'GET',
            ...params,
        }),
    };
    portal = {
        /**
         * No description
         *
         * @tags Portal
         * @name PortalCreate
         * @summary Login to portal
         * @request POST:/api/portal/
         */
        portalCreate: (data, params = {}) => this.request({
            path: `/api/portal/`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Portal
         * @name PortalWithTgCreate
         * @summary Login to portal with telegram
         * @request POST:/api/portal-with-tg/
         */
        portalWithTgCreate: (data, params = {}) => this.request({
            path: `/api/portal-with-tg/`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    queue = {
        /**
         * No description
         *
         * @tags Queue
         * @name QueueList
         * @summary Queue
         * @request GET:/api/queue/
         */
        queueList: (params = {}) => this.request({
            path: `/api/queue/`,
            method: 'GET',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Queue
         * @name QueueCheckcontractList
         * @summary Queue
         * @request GET:/api/queue/checkcontract
         */
        queueCheckcontractList: (params = {}) => this.request({
            path: `/api/queue/checkcontract`,
            method: 'GET',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Queue
         * @name QueueGenerateEmojiCreate
         * @summary Queue
         * @request POST:/api/queue/generate-emoji
         */
        queueGenerateEmojiCreate: (params = {}) => this.request({
            path: `/api/queue/generate-emoji`,
            method: 'POST',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Queue
         * @name QueueRefreshbalanceCreate
         * @summary Queue
         * @request POST:/api/queue/refreshbalance
         */
        queueRefreshbalanceCreate: (params = {}) => this.request({
            path: `/api/queue/refreshbalance`,
            method: 'POST',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Queue
         * @name QueueStartCreate
         * @summary Queue
         * @request POST:/api/queue/start
         */
        queueStartCreate: (query, params = {}) => this.request({
            path: `/api/queue/start`,
            method: 'POST',
            query: query,
            ...params,
        }),
        /**
         * No description
         *
         * @tags Queue
         * @name QueueStopCreate
         * @summary Queue
         * @request POST:/api/queue/stop
         */
        queueStopCreate: (query, params = {}) => this.request({
            path: `/api/queue/stop`,
            method: 'POST',
            query: query,
            ...params,
        }),
        /**
         * No description
         *
         * @tags Queue
         * @name QueueSweepSolanaCreate
         * @summary Queue
         * @request POST:/api/queue/sweep-solana
         */
        queueSweepSolanaCreate: (params = {}) => this.request({
            path: `/api/queue/sweep-solana`,
            method: 'POST',
            ...params,
        }),
        /**
         * No description
         *
         * @tags Queue
         * @name QueueSweepToAdminCreate
         * @summary Sweep to admin
         * @request POST:/api/queue/sweep-to-admin
         */
        queueSweepToAdminCreate: (data, params = {}) => this.request({
            path: `/api/queue/sweep-to-admin`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    processor = {
        /**
         * @description This endpoint allows to get tx processor health status.
         *
         * @tags Processor
         * @name ProcessorHealthList
         * @request GET:/api/processor/health
         */
        processorHealthList: (params = {}) => this.request({
            path: `/api/processor/health`,
            method: 'GET',
            format: 'json',
            ...params,
        }),
        /**
         * @description This endpoint allows to reload tx processor.
         *
         * @tags Processor
         * @name ProcessorRestartCreate
         * @request POST:/api/processor/restart
         */
        processorRestartCreate: (data, params = {}) => this.request({
            path: `/api/processor/restart`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
        }),
    };
    trending = {
        /**
         * No description
         *
         * @tags Trending
         * @name SplashPointsInfoList
         * @summary Get Splash Points Breakdown by token
         * @request GET:/api/splash-points/info
         */
        splashPointsInfoList: (query, params = {}) => this.request({
            path: `/api/splash-points/info`,
            method: 'GET',
            query: query,
            format: 'json',
            ...params,
        }),
    };
}
//# sourceMappingURL=generatedApi.js.map